import React,{useState,useEffect} from 'react'
import { Col,Row} from "react-bootstrap";
import CustomTextField from './CustomTextField'
export const PinCodeComponent = ({pincode}) => {
    const [PincodeDataList, setPincodeDataList] = useState({
        State: "",
        District: "",
        Block: "",
      });
      const [pincodeError, setPinCodeError] = useState(false);

    useEffect(() => {
        const apiUrl = `https://api.postalpincode.in/pincode/${pincode}`;
    
        fetch(apiUrl)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
          })
          .then((data) => {
            if (data[0].Status === "Success") {
              setPincodeDataList(data[0].PostOffice[0]);
              setPinCodeError(false);
            }
            if (data[0].Status === "Error") {
              setPinCodeError(true);
            }
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
      }, [pincode]);
  return (
    <>
         <Col lg="3" className="mb-3">
                <CustomTextField
                  type="text"
                  name="State"
                  disabled
                  value={PincodeDataList?.State}
                  className="text-gray"
                />
              </Col>
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="text"
                  name="District"
                  disabled
                  value={PincodeDataList?.District}
                  className="text-gray"
                />
              </Col>
    </>
  )
}
